import { Customer, api } from "./customers";

export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const BloodTestsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBloodTestsList: build.query<DasboardCustomersResponse, any>({
      query: (pagi) =>
        `blood_test_collections?page=${pagi?.pageNo}&startDate=${
          pagi?.date?.startDate ? pagi?.date?.startDate : ""
        }&endDate=${pagi?.date?.endDate ? pagi?.date?.endDate : ""}&name=${pagi?.name}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "BloodTests" as const,
                id,
              })),
              { type: "BloodTests", id: "LIST" },
            ]
          : [{ type: "BloodTests", id: "LIST" }],
    }),
    // getBloodTestinExcel: build.mutation<AppoinmentByidResponse, any>({
    //   query: () => `BloodTest_exports`,
    //   providesTags: ["BloodTests"],
    //   transformResponse: (
    //     response: { data: AppoinmentByidResponse },
    //     meta,
    //     arg
    //   ) => response.data,
    // }),
    getBloodTestinExcel: build.mutation<any, Partial<void>>({
      query: () => ({
        url: `BloodTest_exports`,
        method: "get",
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [{ type: "BloodTests", id: "LIST" }],
    }),
  }),
});
export const { useGetBloodTestsListQuery, useGetBloodTestinExcelMutation } =
  BloodTestsApi;
